import { curry } from 'lodash/fp';

/**
 * Curried, iteratee-first util functions
 */
export const matchString = curry((regexp, string) => string.match(regexp));
